import React, { useState } from 'react'
import { mcLeadDetailsConfig } from '../../../config/MessageCenterConfig'
import { MessageThreadModel} from '../../../models/MessageCenterModels'
import MessageThreadsList from '../../MessageCenter/MessageThreadsList'

const CustomerMessagesMainCC = () => {
  const [ conversation, setConversation ] = useState<MessageThreadModel | undefined>(undefined) 


  return (
    <div className="customer-messages-main">
      <MessageThreadsList
        config={mcLeadDetailsConfig} 
        conversation={conversation}
        setConversation={setConversation}        
      />          
    </div>
  )
}

export default CustomerMessagesMainCC